import { Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CommonService } from '../../../services';
import { Router } from '@angular/router';
import { ApiResponse } from '../../../models/api-response.model';
import { Subject, combineLatest } from 'rxjs';
import { PostcodeList } from '../../../models/account-delivery-address';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DatePipe, DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { IAdobeReseller } from '../../../models/amp.model';
import { AdobeService } from '../../../services/adobe.service';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-amp-reseller-edit',
  templateUrl: './amp-reseller-edit.component.html',
  styleUrls: ['./amp-reseller-edit.component.css'],
  providers: [DatePipe]
})
export class AMPResellerEditComponent implements OnInit, OnDestroy {

  public userFormGroup: FormGroup;
  public minDate;
  private resellerId: string;
  programType: string = '';
  details: IAdobeReseller;
  setFullWindow: boolean = true;
  title: string = "Manage Reseller Account";
  loadContent: boolean = false;
  filterInput: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  stateList: string[];
  user_validation_messages: any = {
    "firstNameField": [
      { class: "firstNameValidate", message: "Please enter first name" }
    ],
    "lastNameField": [
      { class: "lastNameValidate", message: "Please enter last name" }
    ],
    "marketSegmentField": [
      { class: "marketSegmentValidate", message: "Please choose market segment/s" }
    ],
    "emailField": [
      { class: "emailValidate", message: "Please enter email" }
    ],
    "addressLine1Field": [
      { class: "addressLine1Validate", message: "Please enter address" }
    ],
    "suburbField": [
      { class: "suburbValidate", message: "Please enter suburb" }
    ],
    "stateField": [
      { class: "stateValidate", message: "Please choose state" }
    ],
    "postcodeField": [
      { class: "postcodeValidate", message: "Please enter postcode" }
    ],
    "phoneField": [
      { class: "phoneValidate", message: "Please enter phone" }
    ]
  };

  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private adobeService: AdobeService,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private router: Router,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    public authService: AuthService,
    @Inject(DOCUMENT) private _document: Document) {
      this.userFormGroup = this.formBuilder.group({
        userGroup: this.getUserGroup()
      });
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 }, 400);
  }

  ngOnInit() {
    combineLatest([
      this.shoppingCartService.getState(),
      this.adobeService.getCurrentAMPResellerId
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([states, resellerId]) => {

        this.resellerId = resellerId;
        this.stateList = states?.states;

        this.getAMPResellerDetails();
      });

  }

  getAMPResellerDetails(): void {
    if (this.resellerId) {
      this.adobeService.getAMPResellerDetails(this.resellerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: IAdobeReseller) => {
            if (response) {
              this.details = response;
              this.populateFields();
            } 
          }, (error: any) => {
              console.info(error);
              this.loadContent = true;
          });
    }
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      resellerIdField: new FormControl({value: "",  disabled: true}),
      creationDateFeild: new FormControl({value: "",  disabled: true}),
      companyNameField: new FormControl(""),
      marketSegmentField: new FormControl([], Validators.compose([Validators.required])),
      addressLine1Field: new FormControl("", Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(""),
      addressLine3Field: new FormControl(""),
      stateField: new FormControl("", Validators.compose([Validators.required])),
      suburbField: new FormControl("", Validators.compose([Validators.required])),
      postcodeField: new FormControl("", Validators.compose([Validators.required])),
      firstNameField: new FormControl("", Validators.compose([Validators.required])),
      lastNameField: new FormControl("", Validators.compose([Validators.required])),
      emailField: new FormControl("", this.commonService.emailValidatorRegex()),
      phoneField: new FormControl("", Validators.compose([Validators.required]))
    });
  }

  populateFields() {
    this.userFormGroup.get("userGroup.resellerIdField").setValue(this.details?.reseller_id);
    this.userFormGroup.get("userGroup.creationDateFeild").setValue(this.datePipe.transform(this.details?.creation_date, 'yyyy-MM-dd' + 'T' + 'HH:mm:ss'));
    this.userFormGroup.get("userGroup.companyNameField").setValue(this.details?.company_name);
    this.userFormGroup.get("userGroup.marketSegmentField").setValue(this.details?.market_segments);
    this.userFormGroup.get("userGroup.addressLine1Field").setValue(this.details?.address_1);
    this.userFormGroup.get("userGroup.addressLine2Field").setValue(this.details?.address_2);
    this.userFormGroup.get("userGroup.addressLine3Field").setValue(this.details?.address_3);
    this.userFormGroup.get("userGroup.stateField").setValue(this.details?.region);
    this.userFormGroup.get("userGroup.suburbField").setValue(this.details?.city);
    this.userFormGroup.get("userGroup.postcodeField").setValue(this.details?.post_code);
    this.userFormGroup.get("userGroup.firstNameField").setValue(this.details?.first_name);
    this.userFormGroup.get("userGroup.lastNameField").setValue(this.details?.last_name);
    this.userFormGroup.get("userGroup.emailField").setValue(this.details?.email);
    this.userFormGroup.get("userGroup.phoneField").setValue(this.details?.phone);
    this.loadContent = true;
  }

  updateAMPReseller(): void {
    if (this.userFormGroup.get("userGroup").valid) {
      let flag = false;
      if (this.userFormGroup.get("userGroup.postcodeField").value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', "Please input valid postcode", "right", "error");
      }
      if (!flag) {
        let inputModel = {} as IAdobeReseller
        inputModel = {
          company_name: this.userFormGroup.get('userGroup.companyNameField').value,
          market_segments: this.userFormGroup.get('userGroup.marketSegmentField').value,
          address_1: this.userFormGroup.get('userGroup.addressLine1Field').value,
          address_2: this.userFormGroup.get('userGroup.addressLine2Field').value,
          address_3: this.userFormGroup.get('userGroup.addressLine3Field').value,
          first_name: this.userFormGroup.get('userGroup.firstNameField').value,
          last_name: this.userFormGroup.get('userGroup.lastNameField').value,
          email: this.userFormGroup.get('userGroup.emailField').value,
          city: this.userFormGroup.get('userGroup.suburbField').value,
          region: this.userFormGroup.get('userGroup.stateField').value,
          post_code: this.userFormGroup.get('userGroup.postcodeField').value,
          phone: this.userFormGroup.get('userGroup.phoneField').value
        };


        this.loadContent = false;
        this.adobeService.updateAMPReseller(this.resellerId, inputModel).subscribe((res: ApiResponse) => {
          if (res && res.status) {
            this.commonService.implementToast(res.responseMessage, "Success");
            this.getAMPResellerDetails();
          } else {
            this.commonService.implementToast(res.responseMessage, "Error");
          }
          this.loadContent = true;
        },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          });
      }
    } else {
      this.isNotValidField("userGroup.firstNameField", this.user_validation_messages.firstNameField);
      this.isNotValidField("userGroup.lastNameField", this.user_validation_messages.lastNameField);
      this.isNotValidField("userGroup.marketSegmentField", this.user_validation_messages.marketSegmentField);
      this.isNotValidField("userGroup.emailField", this.user_validation_messages.emailField);
      this.isNotValidField("userGroup.addressLine1Field", this.user_validation_messages.addressLine1Field);
      this.isNotValidField("userGroup.suburbField", this.user_validation_messages.suburbField);
      this.isNotValidField("userGroup.stateField", this.user_validation_messages.stateField);
      this.isNotValidField("userGroup.postcodeField", this.user_validation_messages.postcodeField);
      this.isNotValidField("userGroup.phoneField", this.user_validation_messages.phoneField);
    }
  }

  validateFields(item: any) {
    if (item.field === "out_email") {
      if (this.userFormGroup.get(item.field).hasError("required")) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      } else if (this.userFormGroup.get(item.field).hasError("email")) {
        this.commonService.showValidator("." + item.class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(item.field).valid) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      }
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('userGroup.postcodeField').setValue(option.postcode);
    this.userFormGroup.get('userGroup.stateField').setValue(option.state);
    this.userFormGroup.get('userGroup.suburbField').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  public toggleCoterm(): void {
    if (!this.userFormGroup.get('userGroup.cotermToggle').value) return;
    this.userFormGroup.get('userGroup.cotermToggle').setValue(!this.userFormGroup.get('userGroup.cotermToggle').value);
  }

  public toggleCommitment(): void {
    if (!this.userFormGroup.get('userGroup.commmitmentToggle').value) return;
    this.userFormGroup.get('userGroup.commmitmentToggle').setValue(!this.userFormGroup.get('userGroup.commmitmentToggle').value);
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "userGroup.emailField") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }

  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }
  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/AMP");
  }
  omit_nonprintable_char(event: any) {
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.userFormGroup.get('userGroup.addressLine1Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.userFormGroup.get('userGroup.addressLine2Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.userFormGroup.get('userGroup.addressLine3Field').setValue(event.target.value);
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
